import { Auth, API } from "aws-amplify";

const show = async () => {
    let apiName = "AdminQueries";
    let path = "/listUsers";
    let myInit = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `${(await Auth.currentSession())
                .getAccessToken()
                .getJwtToken()}`
        }
    };
    const { Users } = await API.get(apiName, path, myInit);
    return Users;
};
const showDetail = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params, // OPTIONAL
        headers: {}
    };
    const ret = await API.get("InasakuAPI", "/inasaku/users", myInit);
    return ret.data;
};
const showAll = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params, // OPTIONAL
        headers: {}
    };
    const ret = await API.get("InasakuAPI", "/inasaku/signup/listusers", myInit);
    return ret.data;
};

export default {
    show,
    showDetail,
    showAll,
};
